import { render, staticRenderFns } from "./Capability.vue?vue&type=template&id=3f765f49&scoped=true&"
import script from "./Capability.vue?vue&type=script&lang=js&"
export * from "./Capability.vue?vue&type=script&lang=js&"
import style0 from "./Capability.vue?vue&type=style&index=0&id=3f765f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f765f49",
  null
  
)

export default component.exports